<template>
  <div>
    <final-recon-form
      :create="create"
      :view="view"
      :change="change"
      @close="$router.push('/client/finalrecon/list')"
    />
  </div>
</template>

<script>
import FinalReconForm from "@/views/admin/components/FinalRecon-form.vue"

export default {
  components: { FinalReconForm },
  props: ['create', 'change', 'view'],
  data: () => ({

  }),
  computed: {

  },
  watch: {

  },
  methods: {

  },
}
</script>
